// extracted by mini-css-extract-plugin
export default {"addressSection":"QQ-z","disabled":"RQ-z","sectionButtons":"SQ-z","logo":"TQ-z"};